import { createSlice } from '@reduxjs/toolkit';
import { setCookie } from '@/libs/utils/cookie-tool';

const initData = {
  data: {},
  uuid: '',
  uid: '',
  accountType: '',
};

const userReducers = createSlice({
  name: 'users',
  initialState: initData,
  reducers: {
    setUUID(state, action) {
      state.uuid = action.payload;
    },
    setUID(state, action) {
      state.uid = action.payload;
    },
    setUserData(state, action) {
      state.data = action.payload;
    },
    setAccountType(state, action) {
      state.accountType = action.payload;
    },
    clearUserData() {
      // 清空用户数据
      setCookie('uuid', '', 0);
      localStorage.removeItem('uid');
      localStorage.removeItem('userData');
      return initData;
    },
  },
});

export const { setUUID, setUID, setUserData, setAccountType, clearUserData } =
  userReducers.actions;

export default userReducers.reducer;
